import { render, staticRenderFns } from "./SubdomainCert.vue?vue&type=template&id=182e2b34&scoped=true&"
import script from "./SubdomainCert.vue?vue&type=script&lang=js&"
export * from "./SubdomainCert.vue?vue&type=script&lang=js&"
import style0 from "./SubdomainCert.vue?vue&type=style&index=0&id=182e2b34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182e2b34",
  null
  
)

export default component.exports